import { IVehicleTile } from '../../../types/vehicleTile';
import { ICarRecommendation } from './types';
import { STATE_ABBREVIATIONS } from '../utilities/constants';

export const mapCarRecommendationToVehicleTile = (item: ICarRecommendation): IVehicleTile => ({
    ...item,
    displayModelName: item.displayModelName ?? item.model,
    trim: item.trim ?? '',
    types: item.vehicleTypes,
    msrp: item.basePrice,
    imageLink: item.heroImageUrl ?? '',
    shippingText: item.transferArrivalDayDescription ?? item.shippingText ?? '',
    storeName: item.storeName ?? '',
    storeCity: item.geoCity ?? '',
    state: item.state ?? '',
    stateAbbreviation: item.stateAbbreviation ?? (item.state ? (STATE_ABBREVIATIONS[item.state] ?? '') : ''),
    lastMadeSaleableDate: item.lastMadeSaleableDate ?? '',
    distance: item.distance ?? undefined,
});
